/**
 * Entwicklungslinie: „Ganze Linie“ + OOS placeholders (TCGdex images, same pattern as Lückenfüller).
 * Does not modify Kl24InventoryReservation internals or gap-filler files.
 */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const TYPE_ORDER = [
    'Normal', 'Feuer', 'Wasser', 'Pflanze', 'Elektro', 'Eis', 'Kampf', 'Gift',
    'Boden', 'Flug', 'Psycho', 'Käfer', 'Gestein', 'Geist', 'Drache', 'Unlicht', 'Stahl', 'Fee',
  ];

  const initTypeFilters = () => {
    const grid = document.querySelector('.kl24-evo-hub__grid');
    if (!grid || grid.dataset.filtersReady === '1') return;
    const tiles = [...grid.querySelectorAll('[data-evo-typen]')];
    const present = new Set();
    tiles.forEach((tile) => {
      (tile.dataset.evoTypen || '')
        .split(',')
        .map((name) => name.trim())
        .filter(Boolean)
        .forEach((name) => present.add(name));
    });
    const types = TYPE_ORDER.filter((name) => present.has(name));
    if (!types.length) return;
    grid.dataset.filtersReady = '1';

    const bar = document.createElement('div');
    bar.className = 'kl24-evo-hub__filters';
    bar.setAttribute('role', 'toolbar');
    bar.setAttribute('aria-label', 'Nach Typ filtern');
    const empty = document.createElement('p');
    empty.className = 'kl24-evo-hub__filter-empty';
    empty.hidden = true;
    empty.textContent = 'Keine Linie für diesen Typ.';

    const buttons = ['', ...types].map((value) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'kl24-evo-hub__chip';
      button.dataset.typ = value;
      button.textContent = value || 'Alle';
      button.setAttribute('aria-pressed', value ? 'false' : 'true');
      bar.appendChild(button);
      return button;
    });
    grid.before(bar);
    grid.after(empty);

    const apply = (value) => {
      let shown = 0;
      tiles.forEach((tile) => {
        const names = (tile.dataset.evoTypen || '').split(',').map((name) => name.trim());
        const on = !value || names.includes(value);
        tile.hidden = !on;
        if (on) shown += 1;
      });
      empty.hidden = shown > 0;
      buttons.forEach((button) => {
        const active = (button.dataset.typ || '') === value;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };
    bar.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !bar.contains(button)) return;
      apply(button.dataset.typ || '');
    });
  };

  const initCardPreview = () => {
    const triggers = [...document.querySelectorAll('[data-kl24-preview]')];
    if (!triggers.length || document.querySelector('.kl24-card-preview')) return;

    const hover = document.createElement('div');
    hover.className = 'kl24-card-preview';
    hover.hidden = true;
    hover.setAttribute('aria-hidden', 'true');
    const hoverImg = document.createElement('img');
    hoverImg.alt = '';
    hoverImg.width = 300;
    hoverImg.height = 419;
    hover.appendChild(hoverImg);
    document.body.appendChild(hover);

    const overlay = document.createElement('div');
    overlay.className = 'kl24-card-preview-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="kl24-card-preview-overlay__panel" role="dialog" aria-modal="true" aria-label="Kartenvorschau">' +
      '<img class="kl24-card-preview-overlay__img" alt="" width="300" height="419">' +
      '<a class="kl24-card-preview-overlay__go" href="#">Zur Karte</a>' +
      '<button type="button" class="kl24-card-preview-overlay__close">Schließen</button>' +
      '</div>';
    document.body.appendChild(overlay);
    const overlayImg = overlay.querySelector('.kl24-card-preview-overlay__img');
    const overlayGo = overlay.querySelector('.kl24-card-preview-overlay__go');
    const overlayClose = overlay.querySelector('.kl24-card-preview-overlay__close');

    const coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    const PREVIEW_W = 300;
    const PREVIEW_H = Math.round((300 * 88) / 63);
    let timer = 0;
    let lastFocus = null;

    const placeHover = (anchor) => {
      const rect = anchor.getBoundingClientRect();
      const margin = 12;
      let left = rect.right + 16;
      let top = rect.top;
      if (left + PREVIEW_W > window.innerWidth - margin) left = rect.left - PREVIEW_W - 16;
      if (left < margin) left = Math.max(margin, window.innerWidth - PREVIEW_W - margin);
      if (top + PREVIEW_H > window.innerHeight - margin) top = window.innerHeight - PREVIEW_H - margin;
      if (top < margin) top = margin;
      hover.style.left = `${Math.round(left)}px`;
      hover.style.top = `${Math.round(top)}px`;
    };

    const hideHover = () => {
      window.clearTimeout(timer);
      timer = 0;
      hover.hidden = true;
      hoverImg.removeAttribute('src');
    };

    const showHover = (el) => {
      const src = el.dataset.previewSrc;
      if (!src) return;
      if (hoverImg.getAttribute('src') !== src) hoverImg.src = src;
      hoverImg.alt = el.dataset.previewLabel || '';
      hover.hidden = false;
      placeHover(el);
    };

    const scheduleHover = (el) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => showHover(el), reducedMotion ? 0 : 150);
    };

    const closeOverlay = () => {
      overlay.hidden = true;
      overlayImg.removeAttribute('src');
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    };

    const openOverlay = (el) => {
      const src = el.dataset.previewSrc;
      const href = el.dataset.previewHref;
      if (!src || !href) return;
      hideHover();
      lastFocus = document.activeElement;
      overlayImg.src = src;
      overlayImg.alt = el.dataset.previewLabel || '';
      overlayGo.href = href;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      overlayClose.focus();
    };

    triggers.forEach((el) => {
      if (!coarse) {
        el.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          scheduleHover(el);
        });
        el.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'touch') return;
          hideHover();
        });
        el.addEventListener('focusin', () => scheduleHover(el));
        el.addEventListener('focusout', (event) => {
          if (el.contains(event.relatedTarget)) return;
          hideHover();
        });
      }
      el.addEventListener('click', (event) => {
        if (event.target.closest('button, product-form, .quick-add, [name="add"]')) return;
        const touch = coarse || event.pointerType === 'touch';
        if (!touch) return;
        event.preventDefault();
        openOverlay(el);
      });
    });

    overlayClose.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeOverlay();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (!overlay.hidden) {
          event.preventDefault();
          closeOverlay();
        } else if (!hover.hidden) {
          hideHover();
        }
        return;
      }
      if (event.key !== 'Tab' || overlay.hidden) return;
      const nodes = [overlayGo, overlayClose];
      const index = nodes.indexOf(document.activeElement);
      if (index === -1) {
        event.preventDefault();
        overlayClose.focus();
        return;
      }
      event.preventDefault();
      const next = event.shiftKey ? (index + nodes.length - 1) % nodes.length : (index + 1) % nodes.length;
      nodes[next].focus();
    });
    window.addEventListener('resize', () => {
      if (!hover.hidden) {
        const open = triggers.find((el) => el.matches(':hover') || el.contains(document.activeElement));
        if (open) placeHover(open);
      }
    });
    window.addEventListener('scroll', () => {
      if (!hover.hidden) hideHover();
    }, { passive: true });
  };

  initTypeFilters();
  initCardPreview();

  const root = document.querySelector('[data-kl24-evo]');
  if (!root) return;

  const TCGDEX_API_DE = 'https://api.tcgdex.net/v2/de';
  const TCGDEX_API_EN = 'https://api.tcgdex.net/v2/en';
  /** Same as Lückenfüller `toImageUrl`. */
  const toImageUrl = (imageBase) => (imageBase ? `${imageBase}/high.webp` : '');

  const showPlaceholderBack = (ph) => {
    const img = ph.querySelector('[data-evo-placeholder-img]');
    const back = ph.querySelector('[data-evo-placeholder-back]');
    if (img) {
      img.classList.add('is-pending');
      img.classList.remove('is-ready');
      img.removeAttribute('src');
    }
    if (back) back.classList.remove('is-hidden');
    ph.classList.add('is-fallback-back');
    ph.classList.remove('has-tcgdex-art');
  };

  const revealPlaceholderImage = (ph, img, back) => {
    img.classList.remove('is-pending');
    img.classList.add('is-ready');
    if (back) back.classList.add('is-hidden');
    ph.classList.remove('is-fallback-back');
    ph.classList.add('has-tcgdex-art');
  };

  const showPlaceholderImage = (ph, url, pokemon) => {
    const img = ph.querySelector('[data-evo-placeholder-img]');
    const back = ph.querySelector('[data-evo-placeholder-back]');
    if (!img || !url) {
      showPlaceholderBack(ph);
      return;
    }
    img.alt = pokemon || img.alt || '';
    const cssW = parseFloat(getComputedStyle(root).getPropertyValue('--kl24-evo-card-img-w')) || 134;
    const cssH = parseFloat(getComputedStyle(root).getPropertyValue('--kl24-evo-card-img-h')) || 188;
    img.width = Math.round(cssW);
    img.height = Math.round(cssH);
    // Eager: placeholder is above the fold on empty stages; lazy can skip onload.
    img.loading = 'eager';
    img.decoding = 'async';
    img.classList.add('is-pending');
    const onOk = () => revealPlaceholderImage(ph, img, back);
    const onFail = () => showPlaceholderBack(ph);
    img.onload = onOk;
    img.onerror = onFail;
    img.src = url;
    // Cached images may complete before handlers attach.
    if (img.complete) {
      if (img.naturalWidth > 0) onOk();
      else onFail();
    }
  };

  /**
   * Resolve card art: DE API first, then EN (same preference as gap-filler).
   * Mapping lives in kl24-evolution-line-defs / stage CSV (`data-evo-tcgdex`).
   */
  const loadPlaceholderArt = async (ph) => {
    const id = (ph.getAttribute('data-evo-tcgdex') || '').trim();
    const pokemon = (ph.getAttribute('data-evo-pokemon') || '').trim();
    if (!id) {
      showPlaceholderBack(ph);
      return;
    }
    const tryLang = async (base) => {
      const res = await fetch(`${base}/cards/${encodeURIComponent(id)}`, {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return null;
      const data = await res.json();
      return toImageUrl(data?.image || '') || null;
    };
    try {
      let url = await tryLang(TCGDEX_API_DE);
      if (!url) url = await tryLang(TCGDEX_API_EN);
      if (url) showPlaceholderImage(ph, url, pokemon);
      else showPlaceholderBack(ph);
    } catch (_) {
      showPlaceholderBack(ph);
    }
  };

  /**
   * Match placeholder art to a live card <img> on this page (exact rendered size).
   * Fallback CSS vars: mobile ≈ 134×188, desktop ≥750 ≈ 144×202.
   */
  const measureCardArt = () => {
    const liveImg =
      root.querySelector(
        '.kl24-evo__card:not(.kl24-evo__card--placeholder) .tcg-card__media img, ' +
          '.kl24-evo__card:not(.kl24-evo__card--placeholder) .card__media img, ' +
          '.kl24-evo__card:not(.kl24-evo__card--placeholder) .media img'
      ) ||
      root.querySelector('.kl24-evo__card:not(.kl24-evo__card--placeholder) img');
    if (!liveImg) return;
    const r = liveImg.getBoundingClientRect();
    if (r.width < 40 || r.height < 40) return;
    const rw = Math.round(r.width);
    const rh = Math.round(r.height);
    root.style.setProperty('--kl24-evo-card-img-w', `${rw}px`);
    root.style.setProperty('--kl24-evo-card-img-h', `${rh}px`);
    root.querySelectorAll('[data-evo-placeholder-img]').forEach((img) => {
      img.width = rw;
      img.height = rh;
      img.style.width = `${rw}px`;
      img.style.height = `${rh}px`;
    });
    root.querySelectorAll('.kl24-evo__placeholder-thumb-wrap').forEach((wrap) => {
      wrap.style.width = `${rw}px`;
      wrap.style.height = `${rh}px`;
    });
  };
  measureCardArt();
  if (document.fonts?.ready) {
    document.fonts.ready.then(() => measureCardArt()).catch(() => {});
  }
  window.addEventListener('resize', () => {
    window.requestAnimationFrame(measureCardArt);
  });

  root.querySelectorAll('[data-evo-placeholder]').forEach((ph) => {
    void loadPlaceholderArt(ph);
  });

  /**
   * Mobile snap strip: tap navigates, drag scrolls.
   * Some browsers suppress <a> click after slight movement inside overflow-x.
   */
  const moreList = root.querySelector('[data-evo-more-list]');
  if (moreList) {
    let tap = null;
    const TAP_PX = 12;
    moreList.addEventListener(
      'pointerdown',
      (ev) => {
        const card = ev.target.closest('a.kl24-evo__more-card');
        if (!card || !moreList.contains(card)) return;
        tap = { x: ev.clientX, y: ev.clientY, card, id: ev.pointerId, moved: false };
      },
      { passive: true }
    );
    moreList.addEventListener(
      'pointermove',
      (ev) => {
        if (!tap || tap.id !== ev.pointerId) return;
        if (Math.abs(ev.clientX - tap.x) > TAP_PX || Math.abs(ev.clientY - tap.y) > TAP_PX) {
          tap.moved = true;
        }
      },
      { passive: true }
    );
    const endTap = (ev) => {
      if (!tap || (ev.pointerId != null && tap.id !== ev.pointerId)) return;
      const { card, moved } = tap;
      tap = null;
      if (moved) return;
      const href = card.getAttribute('href');
      if (!href) return;
      // Force navigation if the browser dropped the click after a near-tap.
      if (ev.type === 'pointercancel') return;
      const mark = `evoTap${Date.now()}`;
      card.dataset.evoTap = mark;
      window.setTimeout(() => {
        if (card.dataset.evoTap === mark) {
          delete card.dataset.evoTap;
          window.location.assign(href);
        }
      }, 280);
    };
    moreList.addEventListener('pointerup', endTap, { passive: true });
    moreList.addEventListener('pointercancel', () => {
      tap = null;
    });
    moreList.addEventListener('click', (ev) => {
      const card = ev.target.closest('a.kl24-evo__more-card');
      if (!card || !moreList.contains(card)) return;
      delete card.dataset.evoTap; // native click won — cancel forced nav
      if (ev.defaultPrevented) {
        const href = card.getAttribute('href');
        if (href) window.location.assign(href);
      }
    });
  }

  /* Whole-line CTA removed — cards are added per stage only. */
})();
